module.exports = __webpack_public_path__ + "img/touxiang.d1608dce.png";